import { StateCreator } from "zustand";
import { User } from "../../api/models";
import { chatAxios } from "../../axios/chatAxios";

export interface UserSlice {
  user: User | null;
  setUser: (user: User | null) => void;
  // Change Promise<void> to Promise<User | null>
  executeGetUser: () => Promise<User | null>;
}

const createUserSlice: StateCreator<UserSlice, [], [], UserSlice> = (set) => ({
  user: null,
  setUser: (user: User | null) => set({ user }),
  executeGetUser: async () => {
    try {
      const axiosUserResponse = await chatAxios.get("/api/v1/user", {
        withCredentials: true,
      });
      const userData = axiosUserResponse.data;
      set({ user: userData });
      return userData; // Return the data here!
    } catch (error) {
      console.error("Error fetching user data:", error);
      set({ user: null });
      throw error;
    }
  },
});

export default createUserSlice;
